export const GO_BACK_ARROW_BUTTON_SIZE = 36;
